"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgMultipleUsersOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M12 13.5c2.668 0 4.001 1.667 4 5 0 1.333-.667 2-2 2H4c-1.333 0-2-.667-2-2 0-3.333 1.335-5 4.004-5H12zm6 0c2.668 0 4.001 1.667 4 5 0 1.333-.667 2-2 2h-2.984c.656 0 .984-1 .984-3 0-1.721-.667-3.055-2-4h2zm-6 2H6.004c-1.283 0-1.95.922-2 2.765L4 18.5h10c0-2-.667-3-2-3zm5.5-9a2.5 2.5 0 110 5 2.5 2.5 0 010-5zM9 3.5a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z' }))); };
exports.default = SvgMultipleUsersOutline;
//# sourceMappingURL=MultipleUsersOutline.js.map